import React from 'react'

const OpenRouteWithLayout = ({ parent: Parent, child, ...rest }) => {
  return <Parent component={child} {...rest} />
}

export default OpenRouteWithLayout
